// this cookie is originally put by a library we're using (Cookie Consent),
// but we read/write it nonetheless to keep everything in sync
const CONKIECONSENT_DISMISSED_COOKIE = 'cookieconsent_dismissed';
const OUR_COOKIE = 'cookie-ack';

function showBanner() {
    const s = document.createElement('script');
    s.async = true;
    s.src = '//cdnjs.cloudflare.com/ajax/libs/cookieconsent2/1.0.9/cookieconsent.min.js';
    document.body.appendChild(s);
}

function avoidPreferenceRetrievalFromNowOn() {
    Hop.setCookie(OUR_COOKIE, 'yes');
}

Hop.defineModule('cookie-use-warning', (root, cfg) => {
    const acknowledgmentEndpoint = '/api/webpref/cookie-use-warning-acknowledgment';

    function storeUserPreferenceOnBannerClosing() {
        $('body').on('touchstart click', '.cc_btn_accept_all', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // eslint-disable-next-line no-invalid-this
            const el = this;

            if (el.offsetParent !== null) {
                el.click();

                if (cfg.connected) {
                    $.ajax({
                        url: acknowledgmentEndpoint,
                        method: 'post',
                        success: avoidPreferenceRetrievalFromNowOn,
                    });
                }

                // should already have been done by Cookie Consent, but let's do it too to clarify behavior
                Hop.setCookie(CONKIECONSENT_DISMISSED_COOKIE, 'yes');
            }
        });
    }

    function showBannerAndHandleClick() {
        setTimeout(() => {
            // our tests force the cookie after this script has run, let's respect that
            if (Hop.getCookie(OUR_COOKIE) === 'yes' || Hop.getCookie(CONKIECONSENT_DISMISSED_COOKIE) === 'yes') {
                return;
            }
            showBanner();
            storeUserPreferenceOnBannerClosing();
        }, 3000);
    }

    if (cfg.connected) {
        if (Hop.getCookie(OUR_COOKIE) === 'yes') {
            // preference already saved server-side
            return;
        }

        if (Hop.getCookie(CONKIECONSENT_DISMISSED_COOKIE) === 'yes') {
            // sync local preference with server one
            $.ajax({
                url: acknowledgmentEndpoint,
                method: 'post',
                success: avoidPreferenceRetrievalFromNowOn,
            });
            return;
        }

        $.get(acknowledgmentEndpoint).done((alreadyAcknowledged) => {
            if (alreadyAcknowledged) {
                avoidPreferenceRetrievalFromNowOn();
            } else {
                showBannerAndHandleClick();
            }
        });
    } else if (Hop.getCookie(CONKIECONSENT_DISMISSED_COOKIE) !== 'yes' && Hop.getCookie(OUR_COOKIE) !== 'yes') {
        showBannerAndHandleClick();
    }
});
